<template>
  <form @submit.prevent class="info-form style03" v-if="results">

    <div class="heading-area">
      <span class="icon-holder">
        <i class="icon-building"></i>
      </span>
      <span class="text">
        {{ $t('banner.hotels') }}
      </span>
    </div>
    
    <input-date-time v-model="quote" :label="$t('airporthotel.filters.night_of_stay')" dateProp="dateA" :time="false" :wrapper="false" />
    
    <input-date-time :min-date="dateA" v-model="quote" :label="$t('airporthotel.filters.parking_until')" dateProp="dateB" :time="false" :wrapper="false" />

    <div class="input-col border-0 room">
      <label class="label-text" for="text06">{{ $t('airporthotel.filters.room_type') }}</label>
      <span class="fake-select">
          <select id="text06" v-model="room1">
            <option 
              v-for="(option, key) in rooms" 
              :key="key" 
              :selected="room1 === option.value" 
              :value="option.value">{{ option.text }}</option>
          </select>
      </span>
    </div>
    <button @click="search" class="submit" type="button">{{ $t('airporthotel.filters.search') }}</button>
  </form>
</template>

<script>
import { get, sync } from "vuex-pathify";
import moment from "moment";
import { eventBus } from "@/eventBus";
import { InputDateTime } from "@/components";
import mixins from "@/mixins";

export default {
  name: "hotel-filters",
  components: { InputDateTime },
  mixins: [mixins.format],
  data() {
    return {
      rooms: [
        { value: "1", text: "Single" },
        { value: "2", text: "Double" },
        { value: "3", text: "Twin" },
        { value: "4", text: "Triple (3 adults)" },
        { value: "5", text: "Family of 3" },
        { value: "6", text: "Family of 4" },
        { value: "7", text: "Family of 5" },
        { value: "1001", text: "Family of 6" },
        { value: "1005", text: "Family of 7" },
        { value: "1008", text: "Executive Single" },
        { value: "1003", text: "Executive Double" },
        { value: "1004", text: "Honeymoon" },
        { value: "1009", text: "Quad (4 adults)" },
        { value: "1010", text: "Exec.Family 4" }
      ],
      dateChanged: 0
    }
  },
  watch: {
    'dateA': {
      handler(val) {
        this.dateChanged++;

        if(this.dateChanged > 1) {
          let pickup = moment(val).add(7, 'd');
          this.dateB = pickup.format()
        }
      }
    }
  },
  computed: {
    results: get("results/products"),
    ...sync("quoteTemp/*"),
    quote: sync("quoteTemp"),
  },
  methods: {
    search(e) {
      e.preventDefault();
      eventBus.$emit("SEARCH");   
    },
  }
};
</script>